import { motion } from "framer-motion";
import SectionTitle from "../ui/SectionTitle";
import {
  FaBriefcase,
  FaCode,
  FaLaptopCode,
  FaRocket,
} from "react-icons/fa";

const timeline = [
  {
    year: "2025 - Present",
    title: "Senior Frontend Developer",
    company: "Remote / Freelance",
    description:
      "Building enterprise React, Next.js and Headless WordPress applications with a strong focus on SEO, performance and user experience.",
    icon: <FaRocket />,
  },
  {
    year: "2018 - 2025",
    title: "Senior Web Developer",
    company: "SMUFTech",
    description:
      "Led frontend development for large-scale business websites, ecommerce stores and custom WordPress solutions for international clients.",
    icon: <FaLaptopCode />,
  },
  {
    year: "2015 - 2018",
    title: "Frontend Developer",
    company: "SMUFTech",
    description:
      "Developed responsive websites using HTML5, CSS3, JavaScript, Bootstrap and WordPress while collaborating with UI/UX designers.",
    icon: <FaCode />,
  },
];

const stats = [
  {
    value: "10+",
    label: "Years Experience",
  },
  {
    value: "1000+",
    label: "Projects",
  },
  {
    value: "200+",
    label: "Happy Clients",
  },
  {
    value: "25+",
    label: "Countries",
  },
];

export default function Experience() {
  return (
    <section
      id="experience"
      className="section bg-[#07101f] relative overflow-hidden"
    >
      <div className="absolute left-0 top-40 h-96 w-96 rounded-full bg-blue-500/10 blur-[120px]" />

      <div className="container">

        <SectionTitle
          subtitle="Experience"
          title="My Professional Journey"
        />

        <div className="grid lg:grid-cols-2 gap-20">

          {/* Timeline */}

          <div className="relative">

            <div className="absolute left-7 top-0 bottom-0 w-px bg-white/10" />

            {timeline.map((item, index) => (

              <motion.div
                key={index}
                initial={{
                  opacity:0,
                  x:-40
                }}
                whileInView={{
                  opacity:1,
                  x:0
                }}
                transition={{
                  duration:.5,
                  delay:index*.15
                }}
                viewport={{
                  once:true
                }}
                className="relative flex gap-8 mb-14"
              >

                <div className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full bg-blue-600 text-white text-xl shadow-lg">

                  {item.icon}

                </div>

                <div className="rounded-3xl border border-white/10 bg-white/5 p-8 w-full">

                  <span className="text-blue-400 uppercase tracking-[3px] text-sm">

                    {item.year}

                  </span>

                  <h3 className="mt-3 text-2xl font-bold">

                    {item.title}

                  </h3>

                  <p className="mt-2 text-white/70">

                    {item.company}

                  </p>

                  <p className="mt-6 text-slate-400 leading-8">

                    {item.description}

                  </p>

                </div>

              </motion.div>

            ))}

          </div>

          {/* Right */}

          <motion.div
            initial={{
              opacity:0,
              x:40
            }}
            whileInView={{
              opacity:1,
              x:0
            }}
            viewport={{
              once:true
            }}
          >

            <div className="rounded-[35px] border border-white/10 bg-gradient-to-br from-blue-600/10 to-white/5 p-10">

              <div className="flex items-center gap-4">

                <div className="h-16 w-16 rounded-2xl bg-blue-600 flex items-center justify-center text-2xl">

                  <FaBriefcase />

                </div>

                <div>

                  <h3 className="text-3xl font-bold">

                    Senior Frontend Developer

                  </h3>

                  <p className="text-slate-400 mt-2">

                    React • Next.js • WordPress

                  </p>

                </div>

              </div>

              <p className="mt-10 leading-8 text-slate-400">

                Over the past decade I've partnered with startups,
                agencies and established businesses to create
                scalable websites and web applications.

                My expertise includes React, Next.js,
                Tailwind CSS, WordPress, WooCommerce,
                Headless CMS architecture and website optimization.

              </p>

              <div className="grid grid-cols-2 gap-6 mt-12">

                {stats.map((item) => (

                  <div
                    key={item.label}
                    className="rounded-2xl border border-white/10 bg-white/5 p-8 text-center"
                  >

                    <h3 className="text-5xl font-black text-blue-500">

                      {item.value}

                    </h3>

                    <p className="mt-3 text-slate-400">

                      {item.label}

                    </p>

                  </div>

                ))}

              </div>

            </div>

          </motion.div>

        </div>

      </div>
    </section>
  );
}